import { useMemo } from "react";
import {
  type AutocompleteArrayInputProps,
  AutocompleteArrayInput,
  useGetList,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const TrafficSourceArrayInput = (
  props: Omit<AutocompleteArrayInputProps, "choices" | "isPending">,
) => {
  const { isPending, data = [] } = useGetList<{
    id: string;
  }>(MODULE_NAMES.TRAFFIC_SOURCES);

  const choices = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        ["@id"]: `/api/vpn/traffic_sources/${item.id}`,
      })),
    [data],
  );

  return (
    <AutocompleteArrayInput
      {...props}
      isPending={isPending}
      optionText="title"
      choices={choices}
    />
  );
};
